module.exports = __webpack_public_path__ + "img/25.e7e3e41.jpg";